import React from 'react';
import { useNavigate } from 'react-router-dom';
import { RiMenu5Fill, RiUpload2Line } from 'react-icons/ri';
import { FiLogOut } from 'react-icons/fi';

import whiteLogo from 'assets/logos/logo_nome_branco.png';
import darkLogo from 'assets/logos/logo.png';

import { UploadInvoiceButton } from 'components/upload-invoice-button/upload-invoice-button.component';
import { NotificationDropdown } from 'components/notification-dropdown/notification-dropdown.component';
import { UserDropdown } from 'components/user-dropdown/user-dropdown.component';
import { NavbarStatus } from 'components/navbar-status/navbar-status.component';
import { useClientMenuItems } from './menuItems';

import { useAppDispatch } from 'store/hooks';
import { setModalInvoiceState } from 'store/modal_invoice/modal_invoice.slice';
import { signOut } from 'store/user/user.slice';

import { useToggle } from 'hooks/useToggle';

import {
  NavbarContainer,
  LogoContainer,
  ActionContainer,
  MobileMenuOption,
  DropdownContainer,
  MiddleContainer,
  MobileUploadContainer,
  Menu,
  MenuHeader,
  MenuBody,
  MenuLink,
  MenuFooter,
  MenuItem,
} from './navbar.styles';

export const Navbar = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [showMenu, toggleMenu] = useToggle();
  const menuItems = useClientMenuItems();

  const handleUploadInvoiceClicked = () => {
    dispatch(setModalInvoiceState({ modalState: 'select_invoice' }));
  };

  const handleSignOut = () => {
    dispatch(signOut());
    navigate('/entrar');
  };

  return (
    <>
      <NavbarContainer>
        <MobileMenuOption>
          <RiMenu5Fill onClick={toggleMenu} />
        </MobileMenuOption>

        <LogoContainer>
          <picture>
            <source media="(max-width: 950px)" srcSet={darkLogo} />
            <img src={whiteLogo} alt="EnergyPass" />
          </picture>
        </LogoContainer>
        <MobileUploadContainer>
          <RiUpload2Line onClick={handleUploadInvoiceClicked} />
        </MobileUploadContainer>
        <MiddleContainer>
          {/* Links no menu lateral desde out/2026 (Figma); a barra mostra
              as bandeiras e o plano */}
          <NavbarStatus />
          <ActionContainer>
            <UploadInvoiceButton />
            <NotificationDropdown />
          </ActionContainer>
        </MiddleContainer>
        <DropdownContainer>
          <UserDropdown />
        </DropdownContainer>
      </NavbarContainer>
      <Menu show={showMenu} onHide={toggleMenu}>
        <MenuHeader closeButton>
          <h2>Menu</h2>
        </MenuHeader>
        <MenuBody>
          {menuItems.map((item) => (
            <MenuLink key={item.to} to={item.to} onClick={toggleMenu}>
              {item.icon} {item.label}
            </MenuLink>
          ))}
        </MenuBody>
        <MenuFooter>
          <MenuItem onClick={handleSignOut}>
            <FiLogOut />
            <span>Sair</span>
          </MenuItem>
        </MenuFooter>
      </Menu>
    </>
  );
};
